import {environment} from '../environments/environment'

export const MEDGESTAO_API = environment.api;
export const MEDGESTAO_APP_API = environment.app_api
export const EXPORT_API = environment.export_api;
